<template>
    <div class="information-banner" :class="classes">
        <div v-if="illustrationPosition === 'left'" class="information-banner__illustration">
            <img :src="sourceIllustration" />
        </div>
        <div class="information-banner__content">
            <h2 class="typographies-heading-h2">
                {{ title }}
            </h2>
            <p v-if="showDescription" class="typographies-paragraph-medium-regular">
                {{ description }}
            </p>
            <slot name="description" />
        </div>
        <div v-if="illustrationPosition !== 'left'" class="information-banner__illustration">
            <img :src="sourceIllustration" />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true,
        },
        description: {
            type: String,
            default: '',
        },
        sourceIllustration: {
            type: String,
            default: '',
        },
        fullIllustration: {
            type: Boolean,
            default: false,
        },
        illustrationPosition: {
            type: String,
            default: 'right',
            validator: (value) => ['left', 'right'].includes(value),
        },
    },
    computed: {
        showDescription() {
            return this.description || this.$slots.description;
        },
        classes() {
            return {
                'information-banner--full-illustration': this.fullIllustration,
            };
        },
    },
};
</script>

<style lang="scss" scoped>
.information-banner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: var(--spacing-3) var(--spacing-5);
    background: var(--colors-common-background-primary-subtle-alt, #4868fd1a);
    border-radius: var(--spacing-0);

    &__content {
        display: flex;
        flex-direction: column;

        h2 {
            margin: 0 0 var(--spacing-0);
            color: var(--colors-common-text-brand-secondary-blue);
        }

        p {
            margin: 0;
            color: var(--colors-common-text-brand-secondary-blue);
        }
    }

    &__illustration {
        padding: 0 var(--spacing-6);

        img {
            max-width: 100px;
            max-height: 100px;
        }
    }
    &--full-illustration {
        padding: 0;
        overflow: hidden;

        .information-banner__content {
            padding: var(--spacing-3) var(--spacing-5);
            flex: 1;
        }

        .information-banner__illustration {
            flex: 0 0 auto;
            padding: 0;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: flex-end;

            img {
                max-width: none;
                max-height: 100%;
                height: 100%;
                object-fit: cover;
                object-position: right center;
            }
        }
    }
}
</style>
